function feed(e) {
  const instaWrap = document.querySelector(".feed__list");

  const localLimit = instaWrap.dataset.limit;
  const videos = instaWrap.dataset.videos;
  const accessToken =
    "IGQWRPMlZATaHZACWWhLZAWVEVUcxNXhPcGxsUmt6SFJXUVEwbzBpSjJyd0VKYW5wRmV4WlFuZAEpiT1FqaDlEMV9PaGFILUFwWWFFWC1kZATluMjJhY2hva0pxRjItN3lUT3dVeWVHaHY4MlVGbXlaaFNkLU0xWWpVOEUZD";
  const fields = "id,media_type,media_url,timestamp,permalink,caption";
  const placeholders = document.querySelectorAll(".feed-placeholder");
  const placeholderCaption = document.querySelector(
    ".feed-placeholder .caption"
  );

  const refreshToken = async () => {
    const superhiApi =
      "https://api.superhi.com/api/test/token/instagram?access_token=" +
      accessToken;
    const response = await fetch(superhiApi);

    const { access_token } = await response.json();
    return access_token;
  };

  const fetchPosts = async () => {
    try {
      const newToken = await refreshToken();
      const apiUrl =
        "https://graph.instagram.com/me/media?fields=+" +
        fields +
        "&access_token=" +
        newToken;

      const response = await fetch(apiUrl);
      const { data } = await response.json();

      placeholders.forEach((placeholder) => {
        placeholder.style.display = "none";
      });

        // Initialize counters for each media type
      const mediaTypeCounts = {
        IMAGE: 0,
        VIDEO: 0,
        CAROUSEL_ALBUM: 0,
      };

      // Count each media type and filter out VIDEO media types
      const filteredData = data.filter((post) => {
        if (mediaTypeCounts[post.media_type] !== undefined) {
          mediaTypeCounts[post.media_type]++; 
        }
        return post.media_type !== 'VIDEO';
      });

    // console.log("Media Type Counts:", mediaTypeCounts);

    let instaData;

    if (videos === "true") {
      instaData = data;
    } else {
      instaData = filteredData;
    }

      instaData.slice(0, localLimit).forEach((post, index) => {
        if (videos === "true") {
          if (post.media_type == "VIDEO") {
            let div = document.createElement("div");

            let video = document.createElement("video");

            video.src = post.media_url;
            video.muted = true;
            video.loop = false;
            video.controls = true;
            video.playsinline = true;
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
            video.preload = "metadata";
            div.appendChild(video);
            video.className = post.media_type;
       

            let container = document.createElement("li");
            container.style.animationDelay = index * 0.4 + "s";
            container.className = "card-instagram ov-gallery__item rad-s ovh";
            container.append(div);
            instaWrap.append(container);
          } else {
            let a = document.createElement("a");
            a.href = post.permalink;
            a.target = "_blank";
            a.setAttribute("aria-label", post.caption);

            let img = document.createElement("img");
            img.src = post.media_url;
            img.sizes =
              "(min-width: 780px) calc(22.03vw - 46px), calc(50vw - 40px)";
            img.width = 600;
            // class
            img.className = "w-100 obj-cover rad-s ovh " + post.media_type;
            img.setAttribute("loading", "lazy");
            img.setAttribute("alt", post.caption);
            a.appendChild(img);

            let container = document.createElement("li");
            container.className = "card-instagram ov-gallery__item";
            container.style.animationDelay = index * 0.4 + "s";
            container.append(a);
            instaWrap.append(container);
          }
        } else {
       

          let a = document.createElement("a");
              a.href = post.permalink;
              a.target = "_blank";
              a.setAttribute("aria-label", post.caption);

          let img = document.createElement("img");
              img.src = post.media_url;
              img.sizes =
                "(min-width: 780px) calc(22.03vw - 46px), calc(50vw - 40px)";
              img.width = 600;
              img.className = "w-100 obj-cover rad-s ovh " + post.media_type;
              img.setAttribute("loading", "lazy");
              img.setAttribute("alt", post.caption);
              a.appendChild(img);

          let container = document.createElement("li");
              container.className = "card-instagram ov-gallery__item";
              container.style.animationDelay = index * 0.4 + "s";
              container.append(a);
              instaWrap.append(container);
        }
      });
    } catch (error) {
      console.log("Cannot Fetch Posts");
      console.error(error);
    }
  };

  fetchPosts();
}

feed();
